import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import FadeIn from '../animations/FadeIn';
import StaggeredFade from '../animations/StaggeredFade';
import HeroButtons from './HeroButtons';

const HeroContent = () => {
  return (
    <div className="text-center">
      <FadeIn delay={0.3}>
          <span className="inline-block px-4 py-1.5 mb-5 text-sm font-semibold text-blue-700 bg-blue-100/80 backdrop-blur-sm rounded-full">
            FÉDÉRATION ÉTUDIANTE
          </span>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold text-gray-900 tracking-tight">
            <span className="relative inline-block px-3 text-white">
            <span className="absolute inset-0 transform -skew-x-12 bg-gradient-to-r from-blue-800 to-blue-500 shadow-lg" />
            <span className="relative">Ensemble</span>
            </span>,&nbsp;
            <span className="inline-block px-0 mb-1"> nous tissons les fils de</span>
            <span className="relative inline-block px-3 text-white">
            <span className="absolute inset-0 transform -skew-x-12 bg-gradient-to-r from-blue-800 to-blue-500 shadow-lg" />
            <span className="relative">l'inclusion numérique</span>
            </span>&nbsp;&#128640;
            </h1>
      </FadeIn>
      
      <FadeIn delay={0.5}>
        <div className="relative">
          <p className="text-lg md:text-2xl text-gray-600 mb-8 mt-8 max-w-4xl mx-auto font-light">
            Nous luttons sans relâche contre la précarité étudiante, promouvons l'égalité des chances 
            et étendons l'accessibilité des outils numériques à tous, sans distinction.
          </p>
        </div>
      </FadeIn>
      <FadeIn delay={0.5}>
        <StaggeredFade baseDelay={0.8}>
          <HeroButtons />
        </StaggeredFade>
      </FadeIn>
    </div>
  );
};

export default HeroContent;